// Add Lookbook Users
export const ADD_LOOKBOOK_USERS_REQUEST = 'ADD_LOOKBOOK_USERS_REQUEST';
export const ADD_LOOKBOOK_USERS_DONE = 'ADD_LOOKBOOK_USERS_DONE';
export const ADD_LOOKBOOK_USERS_FAILED = 'ADD_LOOKBOOK_USERS_FAILED';
export const ADD_LOOKBOOK_USERS_CLEAR_ERRORS = 'ADD_LOOKBOOK_USERS_CLEAR_ERRORS';
export const ADD_LOOKBOOK_USERS_RESET = 'ADD_LOOKBOOK_USERS_RESET';